"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PostTargetRequest } from "@/generated/fastapi";
import { postTarget } from "../api/postTarget";
import { targetsKeys } from "../queries/keys";

export default function useCreateTargetMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PostTargetRequest) => postTarget(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: targetsKeys.all });
    },
  });
}
